export const DRIVER_DEBUG_CODE = '200979'
export const DRIVER_DEBUG_AUTH_TOKEN = `driver-debug-${DRIVER_DEBUG_CODE}`

// Flag de sessao de avaliacao "armada" no proprio dispositivo. O gatilho por URL
// (`?debug=200979`) nao existe no app nativo (sem barra de endereco); ao digitar o
// codigo dentro do app armamos este flag para que o bypass de origem/reCAPTCHA
// (`can_bypass_driver_debug_auth`) tambem valha sem depender da URL. Persistente
// (localStorage) para sobreviver a recarga/reabertura do WebView pelo revisor.
const DRIVER_DEBUG_ARMED_KEY = 'fidelidade_driver_debug_armed'

function debug_storage(): Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null
  } catch {
    return null
  }
}

export function arm_driver_debug_session(storage = debug_storage()): void {
  try {
    storage?.setItem(DRIVER_DEBUG_ARMED_KEY, '1')
  } catch {
    /* storage indisponivel: segue sem persistir */
  }
}

export function disarm_driver_debug_session(storage = debug_storage()): void {
  try {
    storage?.removeItem(DRIVER_DEBUG_ARMED_KEY)
  } catch {
    /* storage indisponivel */
  }
}

export function is_driver_debug_armed(storage = debug_storage()): boolean {
  try {
    return storage?.getItem(DRIVER_DEBUG_ARMED_KEY) === '1'
  } catch {
    return false
  }
}

export function is_driver_debug_request(search = window.location.search): boolean {
  return new URLSearchParams(search).get('debug') === DRIVER_DEBUG_CODE
}

// O que autoriza o modo AVALIACAO e o codigo 200979 (flag armado no dispositivo)
// ou o gatilho `?debug=200979` na URL — NUNCA o host. No WKWebView do iOS o esquema
// nao-especial `capacitor://` faz window.location.hostname virar "opaque host", entao
// qualquer allow-list de host quebrava o acesso do revisor no iOS. A protecao real e
// no backend: o token 200979 so autoriza a CONTA DEMO (ver is_driver_demo_phone).
export function can_bypass_driver_debug_auth(location = window.location): boolean {
  return is_driver_debug_request(location.search) || is_driver_debug_armed()
}
